import * as React from 'react'

import Image from 'src/components/UI/Image/Image'
import Price from 'src/components/Product/Price/Price'
import ProductLink from 'src/components/Product/ProductLink/ProductLink'
import {
  getProductById,
  getPrice,
  getLocalizedProductData,
} from 'src/utils/product'

import styles from './CartItem.module.scss'

type Props = {
  item: any
  cart: any
  handleClick?: () => void
  locale: string
}

class CartItem extends React.Component<Props> {
  handleQuantityChange = async (quantity: number) => {
    try {
      const { cart, item } = this.props
      cart.updateQuantity(item.line, quantity)
    } catch (error) {
      // console.log('Error when updating quantity')
    }
  }

  render() {
    const { item, cart, handleClick, locale } = this.props
    const productId = item.product.product
    const product = getProductById(productId)
    if (!product) {
      return null
    }
    // ('product', product, productId)
    const { quantity } = item
    const image = product ? product.media[0] : null
    const { name, excerpt } = getLocalizedProductData(product, locale)

    const fullName = item.size ? `${name} (${item.size})` : name

    return (
      <div className={styles.cartItem}>
        <div className={styles.imageWrapper}>
          <Image src={image.sources.full.url} alt={name} />
        </div>
        <div className={styles.info}>
          <div>
            <ProductLink product={product} onClick={handleClick}>
              <span className={styles.name}>{fullName}</span>
            </ProductLink>
          </div>
          <div className={styles.price}>
            {quantity} x{' '}
            <Price noStyle price={getPrice(product.markets, cart.country)} />
          </div>
        </div>
        <div className={styles.right}>
          <div className={styles.plusminus}>
            <button
              onClick={() => this.handleQuantityChange(item.quantity - 1)}
              className={styles.button}
            >
              <span>-</span>
            </button>
            <button
              onClick={() => this.handleQuantityChange(item.quantity + 1)}
              className={styles.button}
            >
              <span>+</span>
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default CartItem
